module.exports = __webpack_public_path__ + "img/info.9f8b8ccd.png";